import TopHeader from "components/top/TopHeader";
import { ContextModel } from "models";
import React from "react";
import { Helmet } from "react-helmet-async";
import { Link, useOutletContext } from "react-router-dom";

/**
 * 会社情報登録申請 完了画面 （ログイン前）
 */
const CorpEntryCompletePage: React.FC = () => {
  const ctx = useOutletContext<ContextModel>();
  const didEffect = React.useRef(false);

  React.useEffect(() => {
    if (didEffect.current) {
      return;
    }
    didEffect.current = true;
    ctx.loading.setState(false);
  }, [ctx.loading]);

  return (
    <div>
      <Helmet>
        <title>会社登録申請 完了</title>
      </Helmet>
      <TopHeader />
      <div className="w-9/12 mx-auto">
        <div className="text-center border border-black m-4 p-4">
          <div>会社登録申請が完了しました。</div>
          <hr className="m-4" />
          <div>運営会社にて申し込み内容を審査いたします。</div>
          <div>登録完了しましたら、通知メールにてご連絡いたします。</div>
        </div>
        <div className="flex justify-center gap-4 m-8">
          <a href={process.env.REACT_APP_TOPPAGE_JDP_STG_URL}>
            <button className="secondary px-4 py-2">トップページへ</button>
          </a>
        </div>
      </div>
    </div>
  );
};
export default CorpEntryCompletePage;
